import React from "react";

function Service({ stateObj, setStateObj, UpdateProfile, setCurrentDiv }) {
  return (
    <div className="row">
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">
            Product / Service:
            <small style={{ float: "right" }}>
              {stateObj.servicesoffered?.length || 0} / 250
            </small>
          </label>
          <textarea
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({
                  ...stateObj,
                  servicesoffered: e.target.value,
                });
            }}
            value={stateObj.servicesoffered}
            readOnly={stateObj.activestatus !== "True"}
            className="form-control"
            style={{ minHeight: 100 }}
            id="services"
            name="services"
            placeholder={stateObj.activestatus !== "True" ? "Subscribe To Enter" : "Enter your services here, separated by commas. eg.-: Software, Electronics, etc..."}
            required
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">
            Industries Served:
            <small style={{ float: "right" }}>
              {stateObj.industriesserved?.length || 0} / 250
            </small>
          </label>
          <textarea
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({
                  ...stateObj,
                  industriesserved: e.target.value,
                });
            }}
            value={stateObj.industriesserved}
            readOnly={stateObj.activestatus !== "True"}
            className="form-control"
            style={{ minHeight: 100 }}
            id="industriesserved"
            name="industriesserved"
            placeholder={stateObj.activestatus !== "True" ? "Subscribe To Enter" : "Enter your industries served here, separated by commas. eg.-: Software, Electronics, etc..."}
            required
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">
            Service Areas:
            <small style={{ float: "right" }}>
              {stateObj.serviceareas?.length || 0} / 2000
            </small>
          </label>
          <textarea
            type="text"
            className="form-control"
            placeholder="Enter your service areas here, separated by commas. eg.-: 
Europe, London, etc..."
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (e.target.value.length <= 2000)
                setStateObj({ ...stateObj, serviceareas: e.target.value });
            }}
            value={stateObj.serviceareas}
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Pricing Offered / Accepted:</label>
          <input
            onChange={(e) =>
              setStateObj({ ...stateObj, pricing: e.target.value })
            }
            value={stateObj.pricing}
            className="form-control"
            placeholder="Hourly rates, package deals, or project-based fees"
            id="pricing"
            name="pricing"
          />
        </div>
      </div>

      <div className="form-group">
        <button
          className="btn btn-primary "
          onClick={() => {
            UpdateProfile();
            setCurrentDiv("additionalcompany");
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default Service;
